import { useT } from '@/shared/lib/i18n';
import { Button } from '@/shared/ui';

export type StartCtaProps = {
  isHost: boolean;
  canStart: boolean;
  needMore: boolean;
  onStart: () => void;
};

/**
 * Lobby start affordance. Renders the "Start game" button for the host
 * (disabled until min players reached) or a "waiting for host" line for
 * non-host players.
 */
export const StartCta = ({ isHost, canStart, needMore, onStart }: StartCtaProps) => {
  const t = useT();
  if (!isHost) {
    return <p className="text-center text-sm text-text-dim">{t('online.lobby.waiting_host')}</p>;
  }
  return (
    <Button variant="orange" disabled={!canStart} onClick={onStart}>
      {needMore ? t('online.lobby.need_more_players') : t('online.lobby.start_game')}
    </Button>
  );
};
